import { RavenBadge, RavenModal } from "@ravenpay/raven-bank-ui";
import "../../../../styles/dashboard/terminals/RequestedTerminalIndex.css";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/types";
import Skeleton from "react-loading-skeleton";
import { formatCustomDate } from "../../../../utils/helpers";
import BadgeComponent from "../../../../fragments/badge/BadgeComponent";

interface ModalProps {
  visible?: boolean;
  onClose?: () => void;
  id: number;
  details?: any;
}
const RequestedTerminalDetails = ({
  visible,
  onClose,
  details,
}: ModalProps) => {
  const { loading_request } = useSelector((state: RootState) => state.insights);
  // const dispatch = useDispatch();

  return (
    <RavenModal
      onBtnClick={() => {
        onClose && onClose();
      }}
      btnLabel="Close"
      btnColor="deep-green-light"
      visble={visible}
      onClose={onClose}
    >
      <div className="requested-terminal-general-box-wrap">
        <p className="requested-terminal-header-text">Request Details</p>
        <div className="border-theme details-wrap-general">
          {loading_request ? (
            <Skeleton
              width={250}
              height={25}
              style={{ marginBottom: ".3rem" }}
            />
          ) : (
            // <p className="amount">
            //   Amount: <span> {RavenNumberFormat(amount)}</span>
            // </p>
            <div className="modal-item">
              <p className="item-header">Quantity</p>
              <p className="item-text">{details?.quantity}</p>
            </div>
          )}
          {loading_request ? (
            <Skeleton
              width={250}
              height={25}
              style={{ marginBottom: "1rem" }}
            />
          ) : (
            // <p className="amount">
            //   Amount: <span> {RavenNumberFormat(amount)}</span>
            // </p>
            <div className="modal-item">
              <p className="item-header">Status</p>
              <p className="item-text">
                <div className="badge-content">
                  <RavenBadge
                    text={
                      String(details?.status) === "0" ||
                      String(details?.status) === "1"
                        ? `Pending`
                        : String(details?.status) === "3"
                        ? `Approved`
                        : `Delivered`
                    }
                    type={
                      String(details?.status) === "0" ||
                      String(details?.status) === "1"
                        ? `yellow`
                        : String(details?.status) === "3"
                        ? `green`
                        : `info`
                    }
                  />
                </div>
              </p>
            </div>
          )}
          {loading_request ? (
            <Skeleton
              width={350}
              height={25}
              style={{ marginBottom: "1rem" }}
            />
          ) : (
            <div className="modal-item">
              <p className="item-header">Delivery type</p>
              <p className="item-text">{details?.delivery_option}</p>
            </div>
          )}
          {loading_request ? (
            <Skeleton
              width={300}
              height={25}
              style={{ marginBottom: "1rem" }}
            />
          ) : (
            // <p className="amount">
            //   Amount: <span> {RavenNumberFormat(amount)}</span>
            // </p>
            <div className="modal-item">
              <p className="item-header">Contact</p>
              <p className="item-text">{details?.requested_by}</p>
            </div>
          )}
          {loading_request ? (
            <Skeleton
              width={350}
              height={25}
              style={{ marginBottom: "1rem" }}
            />
          ) : (
            // <p className="amount">
            //   Amount: <span> {RavenNumberFormat(amount)}</span>
            // </p>
            <div className="modal-item">
              <p className="item-header">Email</p>
              <p className="item-text">{details?.email}</p>
            </div>
          )}
          {loading_request ? (
            <Skeleton
              width={300}
              height={25}
              style={{ marginBottom: "1rem" }}
            />
          ) : (
            // <p className="amount">
            //   Amount: <span> {RavenNumberFormat(amount)}</span>
            // </p>
            <div className="modal-item">
              <p className="item-header">Address</p>
              <p className="item-text">
                {details?.address || details?.pickup_location?.address || "---"}
              </p>
            </div>
          )}
          {loading_request ? (
            <Skeleton
              width={350}
              height={25}
              style={{ marginBottom: "1rem" }}
            />
          ) : (
            // <p className="amount">
            //   Amount: <span> {RavenNumberFormat(amount)}</span>
            // </p>
            <div className="modal-item">
              <p className="item-header">Date Requested</p>
              <p className="item-text">
                {formatCustomDate(details.created_at)}
              </p>
            </div>
          )}
        </div>
      </div>
    </RavenModal>
  );
};

export default RequestedTerminalDetails;
